function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AnimatePresence, motion } from 'framer-motion';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import map from 'lodash/map';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import SidebarPersonsLoader from 'components/Loaders/SidebarPersonsLoader';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import Button from 'components/Form/Button';
import Dots from 'svg/dots.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import filterBySearch from './helpers/filterBySearch';
import styles from './PatientsList.pcss';
var _React_PureComponent;
class PendingPatients extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        // eslint-disable-next-line react/prop-types
        const { enrollingSharingRequests, search } = props;
        return filterBySearch(enrollingSharingRequests, 'sharingRequestId', search, state, props.maxPatientLength, 'patient');
    }
    componentDidMount() {
        const { filteredCollectionIds } = this.state;
        this.props.setEnrollingPatientLength(filteredCollectionIds.length);
    }
    componentDidUpdate(prevProps, prevState) {
        const { filteredCollectionIds } = this.state;
        if (prevState.filteredCollectionIds.length !== filteredCollectionIds.length) {
            this.props.setEnrollingPatientLength(filteredCollectionIds.length);
        }
    }
    async onOpenMenu(evt, sharingRequest) {
        evt.preventDefault();
        evt.stopPropagation();
        await this.props.onCloseDropdown();
        this.props.onOpenDropdown(`${constants.ENROLLING_SHARING_REQUEST_DROPDOWN}-${sharingRequest.sharingRequestId}`);
    }
    onReject(evt, sharingRequest) {
        evt.preventDefault();
        evt.stopPropagation();
        this.props.onSetFormContext(sharingRequest);
        this.props.onOpenModal(constants.DECLINE_ENROLL_MODAL);
    }
    renderMenu(sharingRequest) {
        const dropdownId = `${constants.ENROLLING_SHARING_REQUEST_DROPDOWN}-${sharingRequest.sharingRequestId}`;
        if (this.props.openDropdownId !== dropdownId) {
            return null;
        }
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                width: 0
            },
            animate: {
                width: 'auto'
            },
            exit: {
                width: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: "dropdownMenu__container dropdownMenu__container--oposite ml-3",
            children: /*#__PURE__*/ _jsx("ul", {
                className: "dropdownMenu__actions",
                children: /*#__PURE__*/ _jsx("li", {
                    className: "dropdownMenu__action",
                    children: /*#__PURE__*/ _jsx(Button, {
                        onClick: (evt)=>this.onReject(evt, sharingRequest),
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.decline))
                    })
                })
            })
        });
    }
    renderMenuContainer(sharingRequest) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "dropdownMenu",
            children: [
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "dropdownMenu__menuButton",
                    onClick: (evt)=>this.onOpenMenu(evt, sharingRequest),
                    children: /*#__PURE__*/ _jsx(Dots, {
                        className: "dropdownMenu__icon"
                    })
                }),
                /*#__PURE__*/ _jsx(AnimatePresence, {
                    children: this.renderMenu(sharingRequest)
                })
            ]
        });
    }
    renderSharingRequest(sharingRequest) {
        const { sharingRequestId, patient } = sharingRequest;
        const { organizationUID, name } = get(this.props.activeClinicMembership, 'clinic', {});
        const clinicSlug = getSlug(name);
        const patientSlug = getSlug(`${patient.firstName} ${patient.lastName}`);
        const patientId = patient.id;
        const url = this.context.getUrl('hcp-results', {
            clinicSlug,
            organizationUID,
            patientSlug,
            patientId
        });
        return /*#__PURE__*/ _jsx("li", {
            className: cn(styles.item__sidebarList),
            children: /*#__PURE__*/ _jsx(Link, {
                to: url,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row flex-nowrap align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto pr-2",
                            children: /*#__PURE__*/ _jsx(Avatar, {
                                avatarImg: patient.avatar,
                                name: [
                                    patient.firstName,
                                    patient.lastName
                                ],
                                className: cn(styles.item__avatar, styles['item__avatar--marked']),
                                imgClassName: styles.item__avatar__img,
                                initialsClassName: styles.item__avatar__initials
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col px-3",
                            children: /*#__PURE__*/ _jsxs("p", {
                                "data-hj-suppress": true,
                                className: cn(styles.item__name, styles['item__name--withMenu'], {
                                    [styles[`item__name--${this.props.id}`]]: styles[`item__name--${this.props.id}`]
                                }),
                                children: [
                                    patient.firstName,
                                    " ",
                                    patient.lastName
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto pl-2",
                            children: this.renderMenuContainer(sharingRequest)
                        })
                    ]
                })
            })
        }, sharingRequestId);
    }
    render() {
        if (this.props.isInProgress) {
            return /*#__PURE__*/ _jsx(SidebarPersonsLoader, {
                itemsNumber: 5
            });
        }
        return /*#__PURE__*/ _jsx("ul", {
            className: styles.items,
            children: map(this.state.filteredCollection, (sharingRequest)=>this.renderSharingRequest(sharingRequest))
        });
    }
    constructor(props){
        super(props);
        this.state = {
            filteredCollection: [],
            filteredCollectionIds: [],
            search: ''
        };
    }
}
_define_property(PendingPatients, "contextType", AppContext);
_define_property(PendingPatients, "propTypes", {
    // Explicit props
    id: PropTypes.string.isRequired,
    activeClinicMembership: Account.shapes.clinicMembership,
    setEnrollingPatientLength: PropTypes.func,
    maxPatientLength: PropTypes.number,
    // Implicit props
    isInProgress: PropTypes.bool.isRequired,
    openDropdownId: PropTypes.string,
    // Implicit actions
    onOpenDropdown: PropTypes.func.isRequired,
    onCloseDropdown: PropTypes.func.isRequired,
    onOpenModal: PropTypes.func.isRequired,
    onSetFormContext: PropTypes.func.isRequired
});
_define_property(PendingPatients, "defaultProps", {
    setEnrollingPatientLength: ()=>{}
});
const mapStateToProps = (state, props)=>({
        enrollingSharingRequests: selectors.enrollingSharingRequests(state),
        search: selectors.searchSelector(props.id)(state),
        isInProgress: selectors.isFetchEnrollingSharingRequestsInProgress(state),
        openDropdownId: App.selectors.dropdown(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId)),
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown()),
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId)),
        onSetFormContext: (sharingRequest)=>dispatch(App.actions.setFormContext(constants.MERGE_PATIENT_FORM, sharingRequest))
    });
const ConnectedPendingPatients = connect(mapStateToProps, mapDispatchToProps)(PendingPatients);
export default withStyles(styles)(ConnectedPendingPatients);
